import { action } from 'satcheljs/lib/legacy';
import { mailFavoritesStore } from 'owa-mail-favorites-store';
/*
 * Sets state to spawn a context menu attached to a favorite node.
*/
export var showFavoritesContextMenu = action('showFavoriteContextMenu')(function (nodeId, nodeType, folder, anchor) {
    // VSO 13261: Refactor the showHideContextMenu to only takes in the folderId
    mailFavoritesStore.mailFavoritesViewState.contextMenuState = {
        nodeId: nodeId,
        nodeType: nodeType,
        folder: folder,
        anchor: anchor,
        treeType: 'favorites',
    };
});
/*
 * Sets state to close the context menu attached to a favorite node.
*/
export var hideFavoritesContextMenu = action('hideFavoriteContextMenu')(function () {
    mailFavoritesStore.mailFavoritesViewState.contextMenuState = null;
});
//# sourceMappingURL=favoritesContextMenu.js.map